import { type ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { useAuth } from '@/hooks/use-auth';
import { canStartRedemption } from '@/utils/redemption-status';
import { RedemptionBlock } from './redemption-block';
import {
  BannedHeader,
  PendingCard,
  ContactFooter,
} from './banned-dashboard-core';
import type { PendingSummary } from './banned-dashboard-parts';

function usePendingSummary(collectorId: string | undefined) {
  return useQuery({
    queryKey: ['collector-summary', collectorId],
    queryFn: async (): Promise<PendingSummary> =>
      pb.send(`/api/payments/collector/${collectorId}/summary`, {
        method: 'GET',
      }),
    enabled: !!collectorId,
    staleTime: 30_000,
  });
}

export function BannedDashboard(): ReactNode {
  const { user } = useAuth();
  const { data: summary } = usePendingSummary(user?.id);
  if (!user) return null;

  return (
    <div className="flex min-h-dvh items-center justify-center bg-void p-base">
      <div className="w-full max-w-[28rem] space-y-lg md:max-w-[42rem]">
        <BannedHeader user={user} />
        {canStartRedemption(user) && <RedemptionBlock />}
        <PendingCard user={user} summary={summary} />
        <ContactFooter />
      </div>
    </div>
  );
}
